import { useEffect, useState } from 'react';
import { UseStepsProps, UseStepsReturn } from '../types/useSteps.types';
import { STEPS } from '../constants';

const useSteps = ({ isOpen }: UseStepsProps): UseStepsReturn => {
  const [step, setStep] = useState<number>(STEPS.ONE);

  useEffect(
    () => () => {
      if (isOpen) return;

      setStep(STEPS.ONE);
    },
    [isOpen]
  );

  return { step, setStep };
};

export default useSteps;
